import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { meKeys } from './meKeys';
import { type UserProfile, userProfileSchema } from './useGetMe';

interface UpdateProfileInput {
  firstName?: string | null;
  lastName?: string | null;
  phoneNumber?: string | null;
}

// PATCH /api/v1/me — edits first/last/phone. Backend rejects any attempt
// to slip an `email` field through (anti-tampering) and trims input.
// Successful response carries the full updated profile, which we hand to
// React Query directly so the cached `me` view flips instantly without
// a second roundtrip.
export function useUpdateProfile() {
  const queryClient = useQueryClient();

  return useMutation<UserProfile, Error, UpdateProfileInput>({
    mutationFn: async (input) => {
      const raw = await apiClient.patch('api/v1/me', { json: input }).json();
      return userProfileSchema.parse(raw);
    },
    onSuccess: (profile) => {
      queryClient.setQueryData(meKeys.detail(), profile);
    },
  });
}
